module.exports = __webpack_public_path__ + "media/images/sp/articles/popular_contents_costumes-f1531481c952932adaf1667d9472d08a.webp";